import { styled } from '../../../core/theme/styled';

type StyledLogoProps = {
  src: string;
  padding?: boolean;
};

export const StyledLogo = styled.div<StyledLogoProps>`
  height: 80px;
  width: 80px;
  background-size: ${({ padding = true }) => (padding ? '55px' : '80px')};
  background-image: url(${(props) => props.src});
  border-radius: ${(props) => props.theme.roundedCorners.large};
  box-shadow: ${(props) => props.theme.shadows.large};

  background-repeat: no-repeat;
  background-position: center;
`;
